import { calPrice } from './number'

const getUsdPrice = (quoteAsset, xBNBSymbol, cryptoCurrencyRate, price) => {
  if (quoteAsset.toUpperCase().includes('USDT')) {
    return `$${calPrice(price)}`
  }

  const key = Object.keys(cryptoCurrencyRate).find(c => c.includes(quoteAsset))
  price = parseFloat(price, 10)

  if (cryptoCurrencyRate[key] && !quoteAsset.includes('USDT')) {
    return `$${calPrice(price * cryptoCurrencyRate[key])}`
  }

  if (!xBNBSymbol) return ''

  return `$${calPrice(parseFloat(1 / xBNBSymbol.price, 10) * price * cryptoCurrencyRate.BNB_USDT)}`
}

export default getUsdPrice
